module.exports = __webpack_public_path__ + "img/Divii-logo.1fbe7e64.svg";